export enum KEY_NAME {
  BACKSPACE = 'Backspace',
  ENTER = 'Enter',
  ESC = 'Escape',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_UP = 'ArrowUp',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_DOWN = 'ArrowDown',
  TAB = 'Tab',
  SHIFT = 'Shift',
  CLEAR = 'Clear'
}